import { render, staticRenderFns } from "./stationery.vue?vue&type=template&id=75b193fc&scoped=true"
import script from "./stationery.vue?vue&type=script&lang=js"
export * from "./stationery.vue?vue&type=script&lang=js"
import style0 from "./stationery.vue?vue&type=style&index=0&id=75b193fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b193fc",
  null
  
)

export default component.exports